<template>
    <Head title="QM - Pagamentos"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-4xl text-white leading-tight lobster">
                Pagamentos
            </h2>
        </template>

        <div class="py-2 flex flex-wrap justify-center">
            <div class="w-11/12 sm:px-6 lg:px-8">
                <div class="bg-slate-100 overflow-hidden shadow-sm rounded-lg">
                    <div class="bg-slate-100 border-b border-gray-200">
                        <div id="app">
                            <div class="px-6 pt-6">
                                <label for="qmulher">Conta QMulher </label>
                                <input @change="changeAccount" id="qmulher" :checked="accountType === 'PaymentQ'"
                                       value="PaymentQ" name="account_type" v-model="accountType" class="mr-2 leading-tight"
                                       type="radio">
                                <label for="outros">Outras Contas </label>
                                <input @change="changeAccount" id="outros" :checked="accountType === 'PaymentO'"
                                       value="PaymentO" name="account_type" v-model="accountType" class="mr-2 leading-tight"
                                       type="radio">
                            </div>
                            <Table :has_checkbox="false" :total="total" :page="page" :rows="payments"
                                   :site_url="site_url" :columns="columns"></Table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import {Head} from '@inertiajs/inertia-vue3';
import Table from '@/Components/Order/Table.vue';
import Validations from '@/Components/Order/Validations.vue';
import Swal from "sweetalert2";
import {ref} from "vue";
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        BreezeAuthenticatedLayout,
        Head,
        Table,
        Validations
    },
    props: ['payments', 'site_url', 'total', 'model', 'filters'],
    setup(props) {
        const page = ref(props.filters.offset === 0 ? 1 : props.filters.offset / props.filters.limit + 1);

        let accountType = ref(props.model);

        function changeAccount() {
            Inertia.get(props.site_url + '/payments/' + accountType.value);
        }

        function load() {
            document.getElementById('loader').classList.toggle('hidden');
        }

        const options = {
            onBefore: function () {
                load();
            },
            onSuccess: function (result) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    html: 'Encomenda criada com sucesso com o nr ' + result.props.order_id + ' <br/><br/> <a class="text-sky-900 font-bold" target="_blank" href="' + props.site_url + '/orders/' + result.props.token + '">' + props.site_url + '/orders/' + result.props.token + '</a>'
                }).then(function () {
                    navigator.clipboard.writeText(props.site_url + '/orders/' + result.props.token).then(function () {
                        console.log('Copying to clipboard was successful!');
                    });
                    load();
                });
                form.reset();
            },
            onError: function () {
                load();
            }
        }

        const columns = [
            {
                label: "",
                field: "id",
                isKey: true,
                display: function () {
                    return null;
                }
            },
            {
                label: "Data",
                field: "date",
                width: "50%",
                sortable: true
            },
            {
                label: "Descrição",
                field: "description",
                width: "50%",
                sortable: true
            },
            {
                label: "Valor",
                field: "value",
                width: "50%",
                sortable: true
            }
        ];

        return {options, accountType, changeAccount, columns, page}

    }
}
</script>
